import React from 'react';
import { constructImageUrl } from 'common/utils';
import useTranslation from 'next-translate/useTranslation';
import { EmptyState } from '..';

type Props = {
  onClick?: () => void;
};

const AccessDenied: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation('errorPages');
  return (
    <EmptyState
      title={t('accessDenied.title')}
      imageUrl={constructImageUrl('errorPages/lock.svg')}
      subTitle={t('accessDenied.subTitle')}
      buttonText={t('accessDenied.login')}
      onClick={onClick}
    />
  );
};

export default AccessDenied;
